import moment from "moment";
import { ContractCheckoutAPI } from "../api";
import { Invoice } from "./Invoice.class";
import { Receipt } from "./Receipt.class";
import i18n from '@/plugins/vue-i18n';
import Vue from "vue";

export class ContractCheckout {
  constructor(props) {
    this.objectId = props.objectId || "";
    this.date = props.date?.iso || moment().toISOString();
    this.dueDate = props.dueDate?.iso || moment().toISOString();

    this.areas = props.areas || [];
    this.isCloseContract = props.isCloseContract || false;

    this.checkOutTotalCost = props.checkOutTotalCost || 0;
    this.checkOutInvoices = props.checkOutInvoices?.map(i => {
      if ((i.isSent || true) && !i.isPaid && !props.checkOutTotalCost) {
        this.checkOutTotalCost += i.totalValue;
      }
      return {
        ...i
      };
    });
    if (this.checkOutInvoices && this.checkOutInvoices.length) {
      for (let checkOutInvoice of this.checkOutInvoices) {
        if (checkOutInvoice?.invoice?.receipts?.length) {
          checkOutInvoice.invoice.receipts = checkOutInvoice.invoice.receipts.map(r => new Receipt(r))
        }
      }
    }
    this.depositTotalCost = props.depositTotalCost || 0;
    this.depositInvoices = props.depositInvoices?.map(i => {
      if (i.isSent && i.isPaid && !props.depositTotalCost) {
        this.depositTotalCost += i.totalValue;
      }
      return {
        ...i
      };
    });
    if (this.depositInvoices && this.depositInvoices.length) {
      for (let depositInvoice of this.depositInvoices) {
        if (depositInvoice?.invoice?.receipts?.length) {
          depositInvoice.invoice.receipts = depositInvoice.invoice.receipts.map(r => new Receipt(r))
        }
        let creditNote = props.creditNotes && props.creditNotes.length && depositInvoice.invoice ? props.creditNotes.find(cn => cn.invoice && cn.invoice.objectId == depositInvoice.id) : null
        if (creditNote) depositInvoice.invoice.creditNote = creditNote
      }
    }
    this.unpaidTotalCost = props.unpaidTotalCost || 0;
    this.unpaidInvoices = props.unpaidInvoices?.map(i => {
      if (i.isSent && !i.isPaid && !props.unpaidTotalCost) {
        this.unpaidTotalCost += i.totalValue;
      }
      return {
        ...i
      };
    });
    if (this.unpaidInvoices && this.unpaidInvoices.length) {
      for (let unpaidInvoice of this.unpaidInvoices) {
        if (unpaidInvoice?.invoice?.receipts?.length) {
          unpaidInvoice.invoice.receipts = unpaidInvoice.invoice.receipts.map(r => new Receipt(r))
        }
      }
    }
    this.isForfeit = props.isForfeit || false
    this.forfeitNote = props.forfeitNote || ''
    this.modeForfeitSelect = props.modeForfeitSelect || 1
    this.forfeitCost = props.forfeitCost || 0
    this.creditNotes = props.creditNotes || []

    this.note = props.note || "";
    this.contract = props.contract || {};
    this.refundBankAccount = props.refundBankAccount || {};
    this.paymentProofFiles = props.paymentProofFiles || [];
    this.paymentMethod = props.paymentMethod == "cash" ? "cash" : "bank";
    this.payDate = props.payDate?.iso || props.payDate || null;
    this.paymentNote = props.paymentNote || '';
    this.isPaid = props.isPaid || false;
    this.summary = props.summary || [];
    this.customerData = props.customerData || {};
    this.expend = false;
    this.status = props.status || "";
    this.paymentMethod = props.paymentMethod || "";
    this.receivedBy = props.receivedBy || {};
    this.statusUpdatedAt = props?.statusUpdatedAt?.iso || null;
    this.invoicePayment = props.invoicePayment || null
    this.checkOutDate = props.checkOutDate?.iso || undefined;
    this.approveStatus = props.approveStatus || null
    this.isSendApproveTask = props.isSendApproveTask || null
    this.isNotClearDebt = props.isNotClearDebt || null
    this.imageFiles = props.imageFiles && props.imageFiles.length ? props.imageFiles : []
    this.market = props.market || null
    this.currencyCode = props.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
    this.currencyRate = props.currencyRate
    this.isEscaped = props.isEscaped || false
  }
  get totalCost() {
    let depositTotalCost = this.depositTotalCost - (this.isForfeit ? parseFloat(this.forfeitCost) : 0)
    const totalCost = depositTotalCost - (this.checkOutTotalCost + this.unpaidTotalCost);
    return totalCost;
  }
  get totalCostAbs() {
    return Math.abs(this.totalCost);
  }
  get refundCost() {
    return this.totalCost > 0 ? Math.abs(this.totalCost) : 0;
  }
  get extraCost() {
    return this.totalCost < 0 ? Math.abs(this.totalCost) : 0;
  }
  get checkOutDateFormet() {
    return this.checkOutDate ? moment(this.checkOutDate).format("DD/MM/YYYY") : "";
  }
  get statusUpdatedAtString() {
    return moment(this.statusUpdatedAt).format("DD/MM/YYYY");
  }
  get unpaidInvoicesTable() {
    return this.unpaidInvoices.map(i => {
      return new Invoice(i.invoice);
    });
  }
  get depositInvoicesTable() {
    return this.depositInvoices.map(i => {
      return new Invoice(i.invoice);
    });
  }
  get checkOutInvoicesTable() {
    return this.checkOutInvoices.map(i => {
      return new Invoice(i.invoice);
    });
  }

  static async getContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async getContractCheckoutData(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutData(payload);
    return new ContractCheckout(data.result);
  }
  static async successContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.successContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async createContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.createContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async sendContractCheckoutApproveTask(payload) {
    const { data } = await ContractCheckoutAPI.sendContractCheckoutApproveTask(payload);
    return new ContractCheckout(data.result);
  }
  static async cancelDraftContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.cancelDraftContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async updateContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.updateContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async clearDebtContractCheckout(contractCheckOutId) {
    const { data } = await ContractCheckoutAPI.clearDebtContractCheckout(contractCheckOutId);
    return new ContractCheckout(data.result);
  }
  get getReceivedBy() {
    let fullName = "";
    if (this.receivedBy) {
      if (this.receivedBy.firstName) fullName += this.receivedBy.firstName + " ";
      if (this.receivedBy.lastName) fullName += this.receivedBy.lastName;
    }
    return fullName;
  }
  static async getContractCheckoutsBetweenDateByMarket(payload) {
    const {
      data
    } = await ContractCheckoutAPI.getContractCheckoutsBetweenDateByMarket(
      payload
    );
    return data.result.map(
      c =>
        new ContractCheckout({
          ...c.contractCheckout,
          summary: c.summary
        })
    );
  }
  static async getContractCheckoutsStatusDateBetweenDateByMarket(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutsStatusDateBetweenDateByMarket(payload);
    return data.result.map(c => new ContractCheckout(c));
  }
  static async getContractCheckoutsByContract(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutsByContract(
      payload
    );
    return data.result.map(c => new ContractCheckout(c));
  }
  static async payContractCheckout(payload) {
    const { data } = await ContractCheckoutAPI.payContractCheckout(payload);
    return new ContractCheckout(data.result);
  }
  static async cancelContractCheckOutInvoicePayment(id) {
    const { data } = await ContractCheckoutAPI.cancelContractCheckOutInvoicePayment(id);
    return new ContractCheckout(data.result);
  }
  static async getContractCheckoutByContractIds(payload) {
    const { data } = await ContractCheckoutAPI.getContractCheckoutByContractIds(payload);
    return data.result.map(c => new ContractCheckout(c));
  }
  get paymentMethodString() {
    return i18n.t(`payment.methods.${this.paymentMethod}`) || "";
  }
  get statusClass() {
    if (this.isSendApproveTask && this.approveStatus == 'pending') {
      return {
        color: "warning",
        css: "text-yellow-600 bg-yellow-50 border-yellow-500",
        text: i18n.t('task.status_wait_approve_checkout')
      }
    } else if (this.isSendApproveTask && this.approveStatus == 'rejected') {
      return {
        color: "error",
        css: "text-red-600 bg-red-50 border-red-500",
        text: i18n.t('task.not_approve')
      }
    } else {
      if (this.status == "success") {
        return {
          color: "primary",
          css: "text-emerald-600 bg-emerald-50 border-emerald-500",
          text: i18n.t('area.status_already_checkout')
        }
      } else if (this.status == "pending") {
        return {
          color: "info",
          css: "text-picton-blue-500 bg-picton-blue-50 border-picton-blue-500",
          text: i18n.t('area.status_wait_checkout')
        }
      } else if (this.status == "draft") {
        return {
          color: "gray",
          css: "text-gray-400 bg-gray-50 border-gray-500",
          text: i18n.t('area.status_draft')
        }
      } else if (this.status == "rejected") {
        return {
          color: "error",
          css: "text-gray-500 bg-gray-50 border-gray-500",
          text: i18n.t('cancel')
        }
      } else {
        return {
          color: "warning",
          css: "text-gray-500 bg-gray-50 border-gray-500",
          text: i18n.t('no_status')
        }
      }
    }
  }
  get sumStatus() {
    if (this.approveStatus != "rejected" && (this.status == 'draft' && this.approveStatus == "draft")) {
      return i18n.t('area.status_draft')
    } else if (this.isSendApproveTask && this.approveStatus == "pending") {
      return i18n.t('payment.wait_approval')
    } else if (this.isSendApproveTask && this.approveStatus == "rejected") {
      return i18n.t('task.not_approve')
    } else if (this.status == "rejected") {
      return i18n.t('area.cancel_draft')
    } else if (this.invoicePayment) {
      return i18n.t('payment.wait_transfer_money')
    } else if (this.isPaid) {
      return this.totalCost > 0
        ? i18n.t('payment.refunded')
        : this.totalCost < 0
          ? i18n.t('payment.paid_money')
          : i18n.t('payment.no_expense')
    } else {
      return this.totalCost > 0
        ? i18n.t('payment.wait_refund')
        : this.totalCost < 0
          ? i18n.t('payment.wait_payment')
          : i18n.t('payment.no_expense')

    }
  }
  get isPaidClass() {
    if (this.approveStatus != "rejected" && (this.status == 'draft' && this.approveStatus == "draft")) {
      return {
        color: "gray",
        css: "text-gray-400 bg-gray-50 border-gray-500",
        text: i18n.t('area.status_draft'),
        chipCss: "text-gray-400 bg-gray-50",
      }
    } else if (this.isSendApproveTask && this.approveStatus == "pending") {
      return {
        color: "warning",
        css: "text-yellow-500 bg-yellow-50 border-yellow-600",
        text: i18n.t('payment.wait_approval'),
        chipCss: "text-yellow-500 bg-yellow-50",
      }
    } else if (this.isSendApproveTask && this.approveStatus == "rejected") {
      return {
        color: "gray",
        css: "text-gray-500 bg-gray-50 border-gray-500",
        text: i18n.t('task.not_approve'),
        chipCss: "text-gray-500 bg-gray-50",
      }
    } else if (this.status == "rejected") {
      return {
        color: "gray",
        css: "text-gray-500 bg-gray-50 border-gray-500",
        text: i18n.t('area.cancel_draft'),
        chipCss: "text-gray-500 bg-gray-50",
      }
    } else if (this.invoicePayment) {
      return {
        color: "yellow accent-4",
        css: "text-yellow-400 bg-yellow-50 border-yellow-400",
        text: i18n.t('payment.wait_transfer_money'),
        chipCss: "text-yellow-400 bg-yellow-50",
      }
    } else if (this.isPaid) {
      if (this.isEscaped) {
        return {
          color: "gray",
          css: "text-gray-600 bg-gray-100 border-gray-600",
          text: i18n.t('bill.bad_debt'),
          chipCss: "text-white bg-gray-700",
        }
      } else {
        return {
          color: "primary",
          css: "text-emerald-600 bg-emerald-50 border-emerald-600",
          text:
            this.totalCost > 0
              ? i18n.t('payment.refunded')
              : this.totalCost < 0
                ? i18n.t('payment.paid_money')
                : i18n.t('payment.no_expense'),
          chipCss: "text-emerald-600 bg-emerald-50",
        }
      }
    } else {
      if (this.totalCost >= 0 ) {
        return {
          color: "info",
          css: "text-picton-blue-500 bg-picton-blue-100 border-picton-blue-600",
          text: i18n.t('payment.wait_refund'),
          chipCss: "text-picton-blue-500 bg-picton-blue-100",
        }
      } else {
        return {
          color: "error",
          css: "text-red-500 bg-red-50 border-red-500",
          text: i18n.t('payment.wait_payment'),
          chipCss: "text-red-500 bg-red-50",
        }
      }
    }
  }
  get areaSum() {
    return this.areas.reduce((acc, i) => acc + i.size, 0);
  }
  get areaNameListString() {
    return this.areas.map(i => i.name).join(", ");
  }
  get cssClass() {
    return {
      paymentTextClass: this.paymentTextClass,
      paymentBorderClass: this.paymentBorderClass,
      paymentBackgroundClass: this.paymentBackgroundClass
    };
  }
  static get status() {
    return this.status || "";
  }
  get checkoutType() {
    if (this.isEscaped) {
      return i18n.t('contract.escaped')
    } else if (this.isCloseContract) {
      return i18n.t('contract.close_contract')
    } else {
      return i18n.t('contract.reduce_area')
    }
  }
}
